export function getLocalStorageItem<T>(key: string, defaultValue: T): string | T {
    if (window.localStorage) {
        const value = window.localStorage.getItem(key);
        if (value !== undefined && value !== null) {
            return value;
        }
    }

    return defaultValue;
}

export function setLocalStorageItem(key: string, value: unknown) {
    if (!window.localStorage) {
        console.error("localStorage is not available.");
        return;
    }

    if (value !== undefined && value !== null) {
        window.localStorage.setItem(key, value.toString());
    } else {
        window.localStorage.removeItem(key);
    }
}

export function getLocalStorageJSON<T = {}>(key: string, defaultValue: T): T {
    const item = getLocalStorageItem(key, null);
    if (item === null) {
        return defaultValue;
    }

    return JSON.parse(item);
}

export function setLocalStorageJSON(key: string, value: unknown) {
    setLocalStorageItem(key, JSON.stringify(value));
}
